import { useEffect } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'

import { AddCartListingSchema } from 'app/validation/schemas/listing/listing.schemas'

type UseFormQuantityProps = { availableQuantity?: number }

const useFormQuantity = ({ availableQuantity }: UseFormQuantityProps) => {
  const defaultValues = {
    item_quantity: 1,
    available_quantity: availableQuantity || 1
  }

  const methods = useForm<AddCartListingFV>({
    resolver: yupResolver(AddCartListingSchema),
    defaultValues,
    mode: 'onChange'
  })

  useEffect(() => {
    methods.reset(defaultValues)
  }, [availableQuantity])

  return methods
}

export default useFormQuantity
